document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
    summary.addEventListener("click", (event) => {
      $(".mini-cart-products").text("");
      var parent_menu = event.target.parentElement.parentElement.id.replace(
        "Details-",
        ""
      );
      var child_menu = document.getElementById(parent_menu);
      $(child_menu).toggleClass("open");
      $(".search-container").removeClass("open");
      $(".mini-cart-products").text("");
    });
  });
});
$(".open.header__icon--cart").on("click", function (event) {
  event.preventDefault();
});

$("#cart-icon-bubble").on("click", function (event) {
  event.preventDefault();
  $(".custom-child-menu").removeClass("open");
  $(".search-container").removeClass("open");
  $(".menu-mobile").removeClass("open");
  if (!$(this).hasClass("clicked")) {
    $(this).addClass("clicked");
    var $cartIcon = $(this);
    $.getJSON("/cart.js", function (cart) {
      console.log(cart);
      if (cart["items"].length === 0) return;

      var outletLabelName = window.outletLabelName || "מחיר עודפים";
      var outletLabelTag = "_label_" + outletLabelName;

      var tagFetches = cart["items"].map(function (item) {
        return $.getJSON("/products/" + item.handle + ".js").then(function (p) {
          return p && p.tags ? p.tags : [];
        }, function () {
          return [];
        });
      });

      $.when.apply($, tagFetches).done(function () {
        var tagsByItem = cart["items"].length === 1 ? [arguments[0]] : Array.prototype.slice.call(arguments);

        var cart_list = [];
        for (var i = 0; i < cart["items"].length; i++) {
          var item_id = cart["items"][i]["id"];
          var product_title = cart["items"][i]["product_title"];
          var quantity = cart["items"][i]["quantity"];
          var line_price = cart["items"][i]["price"] / 100;
          var url = cart["items"][i]["url"];
          var image_url = cart["items"][i]["image"];
          var variants = cart["items"][i]["variant_options"];
          var key = cart["items"][i]["key"];
          var product_url = product_title == "Gift Wrap" ? product_title : '<a href="' + url + '">' + product_title + "</a>";

          var options = [];
          for (var o = 0; o < variants.length; o++) {
            var selected = cart["items"][i]["variant_options"][o];
            if (selected !== "Default Title") options.push(selected + " ");
          }
          var selected_options = options.join("");

          var tags = tagsByItem[i] || [];
          var isOutlet = false;
          for (var t = 0; t < tags.length; t++) {
            if (String(tags[t]).toLowerCase() === "outlet" || tags[t] === outletLabelTag) {
              isOutlet = true;
              break;
            }
          }

          var outletClass = isOutlet ? " cartpopup-item--outlet" : "";
          var priceStyle = isOutlet ? ' style="color:#d72c2c"' : "";
          var outletPrefix = isOutlet ? ' <span class="cartpopup-item__outlet-label" style="color:#000">' + outletLabelName + ':</span>' : "";

          cart_list.push(
            '<div class="cartpopup-item d-flex flex-row' + outletClass + '">\
	                      <div class="cartpopup-item-image">\
	                          <a href="' + url + '">\
	                              <img class="img-fluid d-block" src="' + image_url + '"  alt="' + product_title + '" />\
	                          </a>\
	                      </div>\
	                      <div class="cartpopup-item-content d-flex flex-column">\
	                          <h5>' + product_url + '</h5>\
	                          <span class="variant">' + selected_options + '</span>\
	                          <span class="price"' + priceStyle + '>' + line_price + ' ש״ח ' + outletPrefix + '</span>\
	                          <div class="d-flex flex-row">\
	                              <a class="remove" href="/cart/change?id=' + key + '&amp;quantity=0">הסרה</a>\
	                          </div>\
	                      </div>\
	                  </div>'
          );
        }
        cart_list.push(
          '<div class="cartpopup-footer d-flex flex-row">\
              <form action="/cart" method="post" id="cart-notification-form">\
                 <button class="button button--primary button--full-width" name="checkout">לתשלום</button>\
              </form>\
              <button type="button" class="link button-label close-minicart">להמשך רכישה</button>\
          </div>'
        );
        $(".mini-cart-products").html(cart_list.join(""));
        $("a#cart-icon-bubble").removeClass("closed");
        $cartIcon.addClass("open");
      });
    });
  } else {
    $(this).removeClass("clicked");
    $(".mini-cart-products").text("");
    $("a#cart-icon-bubble").removeClass("open");
    $(this).addClass("closed");
  }
});
$(document).on("click", ".close-minicart", function (event) {
  $(".mini-cart-products").text("");
  $("#cart-icon-bubble").removeClass("clicked");
});

$(".search-trigger").on("click", function (event) {
  event.preventDefault();
  $(".search-container").toggleClass("open");
  $(".custom-child-menu").removeClass("open");
  $(".mini-cart-products").text("");
});

$(".mobile-menu-trigger").on("click", function (event) {
  event.preventDefault();
  $(".search-container").removeClass("open");
  $(".custom-child-menu").removeClass("open");
  $(".mini-cart-products").text("");
  $(".menu-mobile").toggleClass("open");
  $(".header-wrapper").toggleClass("menu-mobile-opened");
  if ($(".menu-mobile").hasClass("open")) {
    // $(".header-wrapper").addClass("menu-mobile-opened");
    $(".mobile-menu-trigger .icon-hamburger").hide();
    $(".mobile-menu-trigger .icon-close").show();
  } else {
    $(".mobile-menu-trigger .icon-hamburger").show();
    $(".mobile-menu-trigger .icon-close").hide();
    // $(".header-wrapper").removeClass("menu-mobile-opened");
  }
});



$(document).ready(function () {
  var previousViewportWidth = document.documentElement.clientWidth;

  $(window).resize(function () {
    var currentViewportWidth = document.documentElement.clientWidth;

    // Ignore height-only resize events caused by mobile browser bars.
    if (currentViewportWidth === previousViewportWidth) return;

    previousViewportWidth = currentViewportWidth;
    $(".search-container").removeClass("open");
    $(".custom-child-menu").removeClass("open");
    $(".mini-cart-products").text("");
    $(".menu-mobile").removeClass("open");
  });
});